// Fronted/src/services/campusService.js
import api from './api';

const campusService = {
  getAllCampuses: async () => {
    try {
      const response = await api.get('/campuses');
      return response.data;
    } catch (error) {
      console.error('Error fetching campuses:', error);
      throw error;
    }
  },

  getCampusById: async (id) => {
    try {
      const response = await api.get(`/campuses/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching campus ${id}:`, error);
      throw error;
    }
  },

  createCampus: async (campusData) => {
    try {
      const response = await api.post('/campuses', campusData);
      return response.data;
    } catch (error) {
      console.error('Error creating campus:', error);
      throw error;
    }
  },

  updateCampus: async (id, campusData) => {
    try {
      const response = await api.put(`/campuses/${id}`, campusData);
      return response.data;
    } catch (error) {
      console.error(`Error updating campus ${id}:`, error);
      throw error;
    }
  },

  deleteCampus: async (id) => {
    try {
      const response = await api.delete(`/campuses/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting campus ${id}:`, error);
      throw error;
    }
  },

  getCampusEvents: async (id) => {
    try {
      const response = await api.get(`/campuses/${id}/events`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching events for campus ${id}:`, error);
      throw error;
    }
  },

  getCampusMinistries: async (id) => {
    try {
      const response = await api.get(`/campuses/${id}/ministries`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ministries for campus ${id}:`, error);
      throw error;
    }
  }
};

export default campusService; 